import React from "react";
import { Modal } from "antd";

export default function FullScreenModal(props) {
  return (
    <Modal
      styles={{
        body: {
          overflowY: "auto",
          flex: 1,
        },
        wrapper: {
          overflow: "unset",
        },
        content: {
          position: "relative",
          height: "-webkit-fill-available",
          height: "100svh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        },
      }}
      style={{
        width: "100%",
        top: 0,
        height: "100%",
        margin: 0,
        maxWidth: "100%",
      }}
      footer={null}
      {...props}
    >
      {props.children}
    </Modal>
  );
}
